// Built @Wed, 27 Dec 2023 03:56:16 GMT
const VERSION = "0.11.38";
export {
  VERSION as default
};
